import React from 'react'
import ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import loadTheme from './utils/colorTheme';
import { getMapiDataRequestURL, getMapiData, getMapiCache, setMapiCache } from 'utils/mapiData'

function buildInitialSelectedFilters(filtersProp) {
  const initial = {
    cinema: [],
    movie: [],
    attrs: [],
    genre: [],
    rating: [],
    other: [],
  }
  if (filtersProp) {
    Object.keys(filtersProp).forEach((key) => {
      if (
        filtersProp[key] &&
        filtersProp[key].length &&
        Object.prototype.hasOwnProperty.call(initial, key)
      ) {
        initial[key] = filtersProp[key]
      }
    })
  }
  return initial
}

/**
 * When FE cache is enabled: warm session/local storage for the initial query key.
 * Uses localized initialData when present (no network). Otherwise GET + setMapiCache.
 */
async function ensureMapiFrontendCache() {
  const initialSelectedFilters = buildInitialSelectedFilters(filters)
  const mapiDataRequestURL = await getMapiDataRequestURL(
    ajaxURL,
    single_cinema,
    single_movie,
    use_site_as_filter,
    initialSelectedFilters,
    test_cinemas_enalbled,
    concessionEnabledParam
  )

  if (getMapiCache(mapiDataRequestURL.filters)) {
    return
  }

  if (initialData) {
    setMapiCache(
      mapiDataRequestURL.filters,
      initialData,
      mapi_cache_expiration
    )
    return
  }

  const mapiData = await getMapiData(mapiDataRequestURL.full)
  if (mapiData) {
    setMapiCache(
      mapiDataRequestURL.filters,
      mapiData,
      mapi_cache_expiration
    )
  }
}

const reactAppData = window.rpReactPlugin || {}
const { 
	appSelector,
	footerAppSelector,
	ajaxURL,
  single_cinema,
  home_url,
  use_site_as_filter,
  filters,
  hide_filters,
  color_scheme,
  movie_name,
  single_movie,
  show_all_movies,
  show_search,
  concession_btn_text,
  concession_site_link,
  concession_link_new_tab,
  concessionEnabledParam,
  mapi_cache_expiration,
  disable_fe_cache,
  test_cinemas_enalbled,
  initialData
} = reactAppData
const appAnchorElement = document.querySelector(appSelector);
const appAnchorFooterElement = document.querySelector(footerAppSelector);

loadTheme(color_scheme);

const mountedRoots = new WeakMap();

const renderApp = (element, anchor) => {
  if (!anchor) {
    return;
  }

  if (typeof ReactDOM.render === 'function') {
    ReactDOM.render(element, anchor);
    return;
  }

  let root = mountedRoots.get(anchor);
  if (!root) {
    root = createRoot(anchor);
    mountedRoots.set(anchor, root);
  }

  root.render(element);
}

async function init() {
  if (!appAnchorElement && !appAnchorFooterElement) {
    return;
  }

  if (!disable_fe_cache) {
    await ensureMapiFrontendCache()
  }

  if (appAnchorElement) {
    renderApp(
      <React.StrictMode>
        <App 
          dataUrl={ajaxURL} 
          isPopup={false} 
          singleCinema={single_cinema} 
          homeURL={home_url}
          useSiteAsFilter={use_site_as_filter}
          filters={filters}
          hideFilters={hide_filters}
          colorScheme={color_scheme}
          movieName={movie_name}
          singleMovie={single_movie}
          showAllMovies={show_all_movies}
          showSearch={show_search}
          concessionBtnText = {concession_btn_text}
          concessionSiteLink={concession_site_link}
          concessionLinkNewTab={concession_link_new_tab}
          concessionEnabledParam={concessionEnabledParam}
          mapiCacheExpiration={mapi_cache_expiration}
          disableCache={disable_fe_cache}
          testCinemasEnabled={test_cinemas_enalbled}
          initialData={initialData || null}
        />
      </React.StrictMode>,
      appAnchorElement
    )
  }

  if (appAnchorFooterElement) {
    renderApp(
      <React.StrictMode>
        <App 
          dataUrl={ajaxURL} 
          isPopup={true} 
          singleCinema={single_cinema} 
          homeURL={home_url}
          useSiteAsFilter={use_site_as_filter}
          filters={filters}
          hideFilters={hide_filters}
          colorScheme={color_scheme}
          movieName={movie_name}
          singleMovie={single_movie}
          showAllMovies={show_all_movies}
          showSearch={show_search}
          concessionBtnText = {concession_btn_text}
          concessionSiteLink={concession_site_link}
          concessionLinkNewTab={concession_link_new_tab}
          concessionEnabledParam={concessionEnabledParam}
          mapiCacheExpiration={mapi_cache_expiration}
          disableCache={disable_fe_cache}
          testCinemasEnabled={test_cinemas_enalbled}
          initialData={initialData || null}
        />
      </React.StrictMode>,
      appAnchorFooterElement
    )
  }
}

init();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
